import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { AppDispatch } from '../../store';
import { ICreatePassFormProps } from '../../interfaces/account/signup';
import { resetAuth } from '../../stores/auth-slice';
import { IError } from '../../interfaces/user/errors';
import { createNewPassword } from '../../data-access/apis/authentication/auth';

const createPassFormProps: ICreatePassFormProps = {
    email: '',
    newPassword: '',
    confirmPassword: '',
};

export const CreatePassHelper = () => {
    const [isProcessing, setIsProcessing] = useState(false);
    const [formErrors, setFormErrors] = useState<IError[]>([]);
    const [values, setValues] = useState<ICreatePassFormProps>(createPassFormProps);
    const account = useSelector((state: any) => state.auth);
    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate();

    const validateEmailAndPassword = () => {
        const errors: IError[] = [];
        if (!values.email) {
            errors.push({ field: 'email', message: 'Please enter your email.' });
        }
        if (!values.newPassword) {
            errors.push({ field: 'newPassword', message: 'Please enter your new password.' });
        }
        if (values.newPassword !== values.confirmPassword) {
            errors.push({ field: 'confirmPassword', message: 'Passwords do not match.' });
        }
        setFormErrors(errors);
        return errors;
    };

    const handleCreatePassword = async (e: React.FormEvent) => {
        e.preventDefault();
        const errors = validateEmailAndPassword();
        if (errors.length > 0) {
            errors.forEach(error => toast.error(error.message, { position: 'bottom-right', autoClose: 3000 }));
            return;
        }
        setIsProcessing(true);
        try {
            await dispatch(createNewPassword(values));
        } catch (error) {
            toast.error('Failed to change password', { position: 'bottom-right', autoClose: 3000 });
        } finally {
            setIsProcessing(false);
        }
    };

    useEffect(() => {
        if (account.statusCode === 200) {
            setIsProcessing(false);
            setValues(createPassFormProps);  // Reset the form fields
            navigate('/auth/sign-in');
            dispatch(resetAuth());
        }
    }, [account.statusCode, navigate, dispatch])

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setValues(prevValues => ({ ...prevValues, [name]: value }));
    };

    return {
        values,
        handleChange,
        formErrors,
        handleCreatePassword,
        isProcessing,
    };
};
